<template>
  <v-content class="full-height" id="notificacoes-page">
    <v-container fluid grid-list-md id="notificacoes" class="full-height">
      <form-alert
        :type="alertText.type"
        :message="alertText.message"
        @close="closeFormAlert"
      />
      <v-layout>
        <h1 class="lightblue--text">Notificações</h1>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap class="mt-4 mb-3" v-if="hasNotifications">
        <v-flex xs1>
          <v-checkbox
            class="checkbox__select-all"
            hide-details
            v-model="selectAll"
          ></v-checkbox>
        </v-flex>
        <v-flex xs11 d-inline-flex>
          <v-btn
            class="jns-button small white-button"
            @click="confirmDialog = true"
            :disabled="!selected.length"
            >Excluir</v-btn
          >
          <v-btn
            class="jns-button small white-button"
            @click="readNotifications()"
            :disabled="!selected.length"
            >Marcar como lido</v-btn
          >
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-pagination
              v-model="page"
              :length="Math.ceil(notificacoes.length / 10)"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
        mt-3
        v-for="(notificacao, index) in paginatedNotificacoes"
        :key="index"
      >
        <v-flex xs12>
          <table width="100%">
            <tr>
              <td width="50px">
                <v-checkbox
                  :value="notificacao.id"
                  :key="notificacao.id"
                  v-model="selected"
                ></v-checkbox>
              </td>
              <td>
                <notificacoes-card
                  class="notificacoes__container"
                  :notificacao="notificacao"
                ></notificacoes-card>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="!hasNotifications">
        <v-flex xs12>
          <v-card>
            <v-card-text class="text-xs-center"
              >Não existem notificações ainda para esse usuário!</v-card-text
            >
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="hasNotifications">
        <v-flex xs12 text-xs-right>
          <v-pagination
            v-model="page"
            :length="Math.ceil(notificacoes.length / 10)"
            :total-visible="7"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="confirmDialog" :max-width="'420'">
      <base-modal>
        <h2 class="title pb-5">
          Tem certeza? Essa ação não pode ser desfeita.
        </h2>
        <v-layout row wrap>
          <v-flex xs4></v-flex>
          <v-flex xs4>
            <button
              class="button jns-button yellow-button"
              @click="deleteNotifications()"
            >
              OK
            </button>
          </v-flex>
          <v-flex xs4>
            <button
              class="button jns-button white-button"
              @click="confirmDialog = false"
            >
              Cancelar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </v-content>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import { mapActions } from "vuex";
export default {
  name: "Notificacoes",
  mixins: [ViewMixin],
  data: () => ({
    page: 1,
    pageSize: 10,
    allSelected: false,
    selected: [],
    confirmDialog: false,
    alertMessage: "Ação concluída com sucesso!",
  }),

  computed: {
    notificacoes() {
      return this.$store.state.notifications.notifications || [];
    },
    hasNotifications() {
      return this.notificacoes.length > 0;
    },
    paginatedNotificacoes() {
      if (!this.notificacoes) return false;

      this.selected = [];

      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.notificacoes.slice(start, end);
    },
    selectAll: {
      get() {
        return this.selected.length === 10; // 10 itens por página
      },
      set(value) {
        this.selected = [];
        if (value) {
          let notificacoesPaginadas = this.getActualPageRegisters();

          notificacoesPaginadas.forEach((select) => {
            this.selected.push(select.id);
          });
        }
        this.allSelected = this.selected.length > 0;
      },
    }, // END selectAll
  },
  methods: {
    ...mapActions([
      "BULK_PATCH_NOTIFICATION_AS_READ",
      "DELETE_NOTIFICATIONS",
      "GET_NOTIFICATIONS",
    ]),

    async init() {},

    // Buscar itens da página selecionada
    getActualPageRegisters() {
      if (!this.notificacoes) return false;

      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.notificacoes.slice(start, end);
    },

    async readNotifications() {
      let selectedNotifications = this.selected;
      let payload = [];

      let notificationsAdapter = (item) => {
        return {
          id: item,
          visualizada: true,
        };
      };
      payload = selectedNotifications.map(notificationsAdapter);

      try {
        await this.BULK_PATCH_NOTIFICATION_AS_READ(payload);
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }
    },
    async deleteNotifications() {
      let selectedNotifications = this.selected;
      let payload = [];

      let notificationsAdapter = (item) => {
        return {
          id: item,
        };
      };
      payload = selectedNotifications.map(notificationsAdapter);

      try {
        this.showLoadingAskWait();
        await this.DELETE_NOTIFICATIONS(payload);
        await this.GET_NOTIFICATIONS();

        this.confirmDialog = false;
        this.alertText = this.handleAlertText2(this.alertMessage);
        this.selected = [];
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }
    },
  },

  mounted() {
    let t = this;
    t.alert = t.handleAlertText();
    this.init();
    // this.notificacoes = t.$settings.mocks.notificacoes
  },
  watch: {
    page(val, oldVal) {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.notificacoes__container {
  width: 100%;
}
#notificacoes-page .jns-button {
  height: 36px;
  width: auto;
}
.checkbox__select-all {
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Notificacoes/Listar.vue